import hero_img1 from "../assets/images/hero-image1.png";
import hero_img2 from "../assets/images/hero-image2.png";
import hero_img3 from "../assets/images/hero-image3.png";

const heroSlides = [
  {
    image: hero_img1,
    title: "حلول مبتكرة في إعادة التدوير",
    description: "نساهم في بناء مستقبل أكثر استدامة",
    buttonText: "اكتشف خدماتنا",
    buttonLink: "/services",
  },
  {
    image: hero_img2,
    title: "نحو بيئة أنظف ومستقبل أفضل",
    description: "خبرات متخصصة في إدارة وإعادة تدوير المخلفات",
    buttonText: "من نحن",
    buttonLink: "/about",
  },
  {
    image:hero_img3,
    title: "شريكك في الاستدامة",
    description: "حلول متكاملة للشركات والمنشآت",
    buttonText: "تواصل معنا",
    buttonLink: "/contact",
  },
];

export default heroSlides;